import {FC} from 'react'

const Error404: FC = () => {
  return (
    <>
      <h1 className='fw-bolder fs-2x text-gray-700 mb-10'>Sayfa Bulunamadı</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        Aradığınız sayfa bulunamadı! <br /> Bu sayfaya yetkiniz olmadığını düşünüyorsanız lütfen sistem yöneticiniz ile iletişime geçin
      </div>
    </>
  )
}

export {Error404}
